// actionTypes.js
export const GET_SHIFTS = "GET_SHIFTS"
export const GET_SHIFTS_SUCCESS = "GET_SHIFTS_SUCCESS"
export const GET_SHIFTS_FAIL = "GET_SHIFTS_FAIL"

export const ADD_SHIFTS = "ADD_SHIFTS"
export const ADD_SHIFTS_SUCCESS = "ADD_SHIFTS_SUCCESS"
export const ADD_SHIFTS_FAIL = "ADD_SHIFTS_FAIL"

export const UPDATE_SHIFTS = "UPDATE_SHIFTS"
export const UPDATE_SHIFTS_SUCCESS = "UPDATE_SHIFTS_SUCCESS"
export const UPDATE_SHIFTS_FAIL = "UPDATE_SHIFTS_FAIL"

export const DELETE_SHIFTS = "DELETE_SHIFTS"
export const DELETE_SHIFTS_SUCCESS = "DELETE_SHIFTS_SUCCESS"
export const DELETE_SHIFTS_FAIL = "DELETE_SHIFTS_FAIL"

export const SET_SHIFT_FIELD_ERRORS = "SET_SHIFT_FIELD_ERRORS"